export const ADD_PRODUCT = 'product/addProduct'
export const MANAGE_QUANTITY = 'carts/manageQuantity'
export const DELETE_CART = 'carts/deleteCart'